export const setCnsInternacao = (state, payload) => {
    state.cnsInternacao = payload;
}

export const setErrorCns = (state, payload) => {
    state.errorCns = payload;
}

export const setListaProcedimentos = (state, payload) => {
    state.listaProcedimentos = payload;
}
export const setListaCid = (state, payload) => {
    state.listaCid = payload;
}
export const setConsolidado = (state, payload) => {
    state.consolidado = payload;
}